import React, { useEffect } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import MainApp from "./MainApp";
import UnavailablePage from "./components/UnavailablePage";
import {useDirAuto} from "./lib/use-dir-auto";

// =====================================================
//  RESTRICTED MODE — flip to true to restrict the system
//    to admin users only. Non-admin users will see the
//    "system unavailable" announcement after logging in.
//    Set back to false to restore normal operation.
// =====================================================
const RESTRICTED_MODE = false;

function App() {
  useDirAuto()

  // Ensure light theme is always applied
  useEffect(() => {
    document.documentElement.classList.remove("dark");
    document.documentElement.classList.add("light");
  }, []);

  return (
    <Router>
      <Routes>
        {/* MainApp handles login + restricted-mode gating for non-admins */}
        <Route path="/*" element={<MainApp restrictedMode={RESTRICTED_MODE} />} />
        {/* <Route path="/compare" element={<ComparePage />} /> */}
        <Route path="/unavailable" element={<UnavailablePage />} />
      </Routes>
    </Router>
  );
}

export default App;